<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Vehicle Management</h1>
  </div>
  <button (click)="openAddModal()" class="h-[48px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2 font-label-md">
    <span class="material-symbols-outlined">add</span>
    Add Vehicle
  </button>
</div>

<div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl flex flex-col overflow-hidden shadow-sm">
  <div class="overflow-x-auto">
    <table class="w-full text-left border-collapse min-w-[700px]">
      <thead>
        <tr class="bg-surface dark:bg-surface-container border-b border-border-subtle dark:border-outline-variant">
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Vehicle</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Make / Model</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">License Plate</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Status</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Active</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium text-right">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-border-subtle dark:divide-outline-variant">
        @if (loading()) {
          <tr>
            <td colspan="6" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading vehicles...</td>
          </tr>
        } @else if (error()) {
          <tr>
            <td colspan="6" class="p-6 text-center text-error font-body-sm">{{ error() }}</td>
          </tr>
        } @else if (vehicles().length === 0) {
          <tr>
            <td colspan="6" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">No vehicles found.</td>
          </tr>
        }
        @for (vehicle of vehicles(); track vehicle.vehicleId) {
          <tr class="hover:bg-surface dark:hover:bg-surface-variant/50 transition-colors group">
            <td class="p-4">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2]">
                  <span class="material-symbols-outlined">local_shipping</span>
                </div>
                <div>
                  <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">{{ vehicle.vehicleName }}</p>
                  <p class="text-text-muted dark:text-on-surface-variant text-xs">ID: {{ vehicle.vehicleId }}</p>
                </div>
              </div>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ vehicle.make }} {{ vehicle.model }}</p>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ vehicle.licensePlate }}</p>
            </td>
            <td class="p-4">
              @if (vehicle.status === 'Available') {
                <span class="inline-flex items-center px-2 py-1 rounded-full bg-[#8DC63F]/10 text-[#8DC63F] font-label-sm border border-[#8DC63F]/20">
                  <span class="w-1.5 h-1.5 rounded-full bg-[#8DC63F] mr-1.5"></span> {{ vehicle.status }}
                </span>
              } @else {
                <span class="inline-flex items-center px-2 py-1 rounded-full bg-[#ef4444]/10 text-[#ef4444] font-label-sm border border-[#ef4444]/20">
                  <span class="w-1.5 h-1.5 rounded-full bg-[#ef4444] mr-1.5"></span> {{ vehicle.status }}
                </span>
              }
            </td>
            <td class="p-4">
              @if (vehicle.isActive) {
                <span class="text-text-main dark:text-on-surface font-body-sm">Active</span>
              } @else {
                <span class="text-text-muted dark:text-on-surface-variant font-body-sm">Inactive</span>
              }
            </td>
            <td class="p-4 text-right">
              <div class="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <button (click)="openEditModal(vehicle)" class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#00B9F2] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors" title="Edit">
                  <span class="material-symbols-outlined text-[20px]">edit</span>
                </button>
                @if (vehicle.isActive) {
                  <button (click)="deactivateVehicle(vehicle)" class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#ef4444] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors" title="Deactivate">
                    <span class="material-symbols-outlined text-[20px]">block</span>
                  </button>
                } @else {
                  <button (click)="activateVehicle(vehicle)" class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#8DC63F] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors" title="Activate">
                    <span class="material-symbols-outlined text-[20px]">check_circle</span>
                  </button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

@if (modalOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4" (click)="closeModal()">
    <div class="bg-background dark:bg-surface-container-low rounded-xl shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <div class="p-lg border-b border-border-subtle dark:border-outline-variant flex items-center justify-between">
        <h2 class="font-headline-sm text-headline-sm text-text-main dark:text-on-surface">
          {{ editingVehicle() === null ? 'Add Vehicle' : 'Edit Vehicle' }}
        </h2>
        <button (click)="closeModal()" class="p-1 rounded-full hover:bg-surface-variant dark:hover:bg-surface-variant text-text-muted dark:text-on-surface-variant">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <form [formGroup]="vehicleForm" (ngSubmit)="saveVehicle()">
        <div class="p-lg grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Vehicle Name *</span>
            <input formControlName="vehicleName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
            @if (vehicleForm.controls.vehicleName.invalid && vehicleForm.controls.vehicleName.touched) {
              <span class="text-xs text-error">Vehicle name is required.</span>
            }
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Make</span>
            <input formControlName="make" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Model</span>
            <input formControlName="model" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">License Plate</span>
            <input formControlName="licensePlate" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Status</span>
            <select formControlName="status"
                    class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
              <option value="Available">Available</option>
              <option value="Unavailable">Unavailable</option>
            </select>
          </label>
        </div>

        <div class="p-lg border-t border-border-subtle dark:border-outline-variant flex items-center justify-end gap-3">
          <button type="button" (click)="closeModal()"
                  class="h-[44px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-md">
            Cancel
          </button>
          <button type="submit" [disabled]="saving()"
                  class="h-[44px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity font-label-md disabled:opacity-50">
            {{ saving() ? 'Saving...' : (editingVehicle() === null ? 'Add Vehicle' : 'Save Changes') }}
          </button>
        </div>
      </form>
    </div>
  </div>
}
